<template>
<div>
    <h1>Turtle</h1>
        <b-row class="turtle-row">
            <b-col class="turtle-cell" cols="4" style="background-color: #f0f0f0">
                <TurtleItem @edit_click="edit_click" @add_btn_click="add_btn_click('material_resources')" @detail_btn_click="detail_btn_click('material_resources')" group="Material resources" :items="get_items('material_resources')" />
            </b-col>
            <b-col class="turtle-cell"></b-col>
            <b-col class="turtle-cell" cols="4" style="background-color: #f0f0f0">
                <TurtleItem @edit_click="edit_click" @add_btn_click="add_btn_click('personnel_resources')" @detail_btn_click="detail_btn_click('personnel_resources')" group="Personnel resources" :items="get_items('personnel_resources')" />
            </b-col>
        </b-row>
        <b-row class="turtle-row">
            <b-col class="turtle-cell" cols="4">
                <TurtleItem @edit_click="edit_click" @add_btn_click="add_btn_click('process_input')" @detail_btn_click="detail_btn_click('process_input')" group="Input" :items="get_items('process_input')" />
            </b-col>
            <b-col class="turtle-cell" align-self="center" style="text-align: center">
                <h4>{{ knowledge_process.name }}</h4>
                {{ knowledge_process.description }}
            </b-col>
            <b-col class="turtle-cell" cols="4">
                <TurtleItem @edit_click="edit_click" @add_btn_click="add_btn_click('process_output')" @detail_btn_click="detail_btn_click('process_output')" group="Output" :items="get_items('process_output')" />
            </b-col>
        </b-row>
        <b-row class="turtle-row">
            <b-col class="turtle-cell" cols="4" style="background-color: #f0f0f0">
                <TurtleItem @edit_click="edit_click" @add_btn_click="add_btn_click('process_management')" @detail_btn_click="detail_btn_click('process_management')" group="Process management" :items="get_items('process_management')" />
            </b-col>
            <b-col class="turtle-cell"></b-col>
            <b-col class="turtle-cell" cols="4" style="background-color: #f0f0f0">
                <TurtleItem @edit_click="edit_click" @add_btn_click="add_btn_click('efficiency')" @detail_btn_click="detail_btn_click('efficiency')" group="Efficiency" :items="get_items('efficiency')" />
            </b-col>
        </b-row>
  </div>
</template>

<script>
import TurtleItem from '@/components/TurtleItem.vue'
import KnowledgeItemForm from '@/components/KnowledgeItemForm.vue'

export default {
  data () {
    return {
    }
  },
  name: 'Turtle',
  props: ['knowledge_items', 'knowledge_process'],
  created () {
  },
  watch: {
      
  },
  components: {
      TurtleItem,
      KnowledgeItemForm
  },
  methods: {
      get_items(group) {
          return this.knowledge_items.filter(function (e) {
              return e.group == group;
          });
      },
      a() {
          console.log("sjdlkf");
      },
      add_btn_click(group) {
          this.$emit('add_btn_click', group);
      },
      detail_btn_click(group) {
          this.$emit('detail_btn_click', group);
      },
      edit_click(item) {
          this.$emit('edit_click', item);
      }
  },
}
</script>
<style>
.turtle-cell {
    border: 0px solid black;
    padding: 10px;
}
.turtle-row {
    min-height: 200px;
}
.turtle-group-left {
    text-align: left;
}
.turtle-group-right {
    text-align: right;
}
</style>